<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.merchantName')">
            <el-select
                v-model="form.appId"
                filterable
                :placeholder="$t('message.chooseOne')"
                popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                  v-for="merchant in merchantList"
                  :label="merchant.value + '-' + merchant.name"
                  :key="merchant.value"
                  :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.rechargeStatus')">
            <el-select v-model="form.status" :placeholder="$t('text.status')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('approvalStatus.00')" value="00"></el-option>
              <el-option :label="$t('approvalStatus.01')" value="01"></el-option>
              <el-option :label="$t('approvalStatus.02')" value="02"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.type')">
            <el-select v-model="form.type" :placeholder="$t('text.type')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('text.recharge')" value="00"></el-option>
              <el-option :label="$t('text.withdrawal')" value="01"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.orderNumber')">
            <el-input v-model="form.orderId" :placeholder="$t('text.orderNumber')" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.date')">
            <el-date-picker
                v-model="timeDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
                :range-separator="$t('text.to')"
                :start-placeholder="$t('text.startDate')"
                :end-placeholder="$t('text.endDate')"
                @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small"
                     v-if="!ROLE_TYPE.isBusinessCustomerServiceManage()">
            {{ $t('text.export') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column
              width="100px"
              prop="createDate"
              :label="$t('text.creationTime')"
              :formatter="$formatter.formatDate"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="type"
              :label="$t('text.type')"
              width="70px"
              :formatter="$formatter.formatRechargeWithdraw"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                  size="small"
                  :type="
                row.type === '00'
                  ? 'warning'
                  : row.type === '01'
                  ? 'success'
                  : 'danger'
              "
              >{{
                  $formatter.formatRechargeWithdraw(null, null, row.type, null)
                }}
              </el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
              prop="selectionType"
              :label="$t('text.rechargeType')"
              width="100px"
              :formatter="$formatter.formatRechargeWithdrawRechargeType"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                  size="small"
                  :type="
                row.selectionType == '00' || row.selectionType == '01'
                  ? 'into'
                  : row.selectionType == '02' || row.selectionType == '03'
                  ? 'warning'
                  : 'danger'
              "
              >{{
                  $formatter.formatRechargeWithdrawRechargeType(null, null, row.selectionType, null)
                }}
              </el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
              width="180px"
              prop="orderId"
              :label="$t('text.orderNumber')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="status"
              :label="$t('text.rechargeStatus')"
              width="80px"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                  size="small"
                  :type="
                row.status == '00'
                  ? 'warning'
                  : row.status == '01'
                  ? 'success'
                  : 'danger'
              "
              >{{ $formatter.formatApprovalStatus(null, null, row.status, null) }}
              </el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
              width="150px"
              prop="dealTime"
              :label="$t('text.processingTime')"
              align="center"
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.dealDate, scope.row.dealTime) }}
            </template>
          </el-table-column>

          <el-table-column
              width="170px"
              prop="appId"
              :label="$t('text.appId')"
              align="center"
          ></el-table-column>
          <el-table-column
              width="120px"
              prop="merchantName"
              :label="$t('text.merchantName')"
              align="center"
          ></el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
              prop="rechargeAmount"
              :label="$t('text.rechargeAmount')"
              width="120px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.type == '00'">
                {{ $formatter.FenToYuanToThousandth(null, null, row.amount, null) }}
              </div>
              <div v-else>
                {{ '--' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="rechargeExchangeRate"
              :label="$t('text.rechargeExchangeRate')"
              width="120px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isEditMode && (row.type == '00')">
                <el-input v-model="rechargeExchangeRateVar"></el-input>
              </div>
              <div v-else-if="(row.rechargeExchangeRate == 0)  || (row.rechargeExchangeRate == null)">
                {{ '--' }}
              </div>
              <div v-else>
                {{ row.rechargeExchangeRate }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="rechargeUSDAmount"
              :label="$t('text.rechargeUSDTAmount')"
              width="120px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="(row.rechargeUSDAmount == 0) || (row.rechargeUSDAmount == null)">
                {{ '--' }}
              </div>
              <div v-else>
                {{ $formatter.FenToYuanToThousandth(null, null, row.rechargeUSDAmount, null) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
              prop="withdrawAmount"
              :label="$t('text.withdrawalAmount')"
              width="120px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.type == '01'">
                {{ $formatter.FenToYuanToThousandth(null, null, row.amount, null) }}
              </div>
              <div v-else>
                {{ '--' }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="withdrawExchangeRate"
              :label="$t('text.withdrawExchangeRate')"
              width="120px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isEditMode && (row.type == '01')">
                <el-input v-model="withdrawExchangeRateVar"></el-input>
              </div>
              <div v-else-if="(row.withdrawExchangeRate == 0)  || (row.withdrawExchangeRate == null)">
                {{ '--' }}
              </div>
              <div v-else>
                {{ row.withdrawExchangeRate }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="withdrawUSDAmount"
              :label="$t('text.rechargeUSDTAmount')"
              width="120px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="(row.withdrawUSDAmount == 0) || (row.withdrawUSDAmount == null)">
                {{ '--' }}
              </div>
              <div v-else>
                {{ $formatter.FenToYuanToThousandth(null, null, row.withdrawUSDAmount, null) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
              width="160px"
              prop="remark"
              :label="$t('text.applicationNote')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.remark">
                <el-popover
                    v-if="row.remark.length > 10"
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="row.remark"
                >
                  <div slot="reference" class="remark">{{ row.remark }}</div>
                </el-popover>
                <div v-else>{{ row.remark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              width="160px"
              prop="approveRemark"
              :label="$t('text.approvalRemark')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.approveRemark">
                <el-popover
                    v-if="row.approveRemark && row.approveRemark.length > 10"
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="row.approveRemark"
                >
                  <div slot="reference" class="remark">
                    {{ row.approveRemark }}
                  </div>
                </el-popover>
                <div v-else>{{ row.approveRemark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              fixed="right"
              :label="$t('text.actions')"
              width="150px"
              align="center"
              v-if="ROLE_TYPE.isManager() && !ROLE_TYPE.isBusinessCustomerServiceManage()">
          >
            <template slot-scope="{ row }">
              <div v-if="!row.isEditMode">
                <el-button
                    type="primary"
                    size="mini"
                    plain
                    @click="startEdit(row)"
                >
                  {{ $t('text.edit') }}
                </el-button>
              </div>
              <div v-else>
                <el-button
                    type="warning"
                    size="mini"
                    plain
                    @click="confirmEdit(row)"
                >
                  {{ $t('text.confirm') }}
                </el-button>
                <el-button
                    type="danger"
                    size="mini"
                    plain
                    @click="cancelEdit(row)"
                >
                  {{ $t('text.cancel') }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import moment from "moment";
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  name: 'Systems',
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
  },
  data() {
    return {
      url: '/depositWithdraw/statistics-recharge-withdraw',
      form: {
        appId: '',
        startDate: moment().subtract(0, 'days').format('yyyyMMDD'),
        endDate: moment().format('yyyyMMDD'),
        tradeOrderId: '',
      },
      rechargeExchangeRateVar: '',
      withdrawExchangeRateVar: '',
      tableData: [],
      timeDate: [moment().subtract(0, 'days').format('yyyyMMDD'),moment().format('yyyyMMDD')],
      merchantList: [],
      loading: false,
      exporting: false,
    }
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = '';
        this.form.endDate = '';
      }
    },
    startEdit(row) {
      this.tableData.forEach(item => {
        item.isEditMode = false;
        this.tableData = [];
      });
      this.tableData.push(row);
      this.$set(row, 'isEditMode', true);
      this.withdrawExchangeRateVar = row.withdrawExchangeRate;
      this.rechargeExchangeRateVar = row.rechargeExchangeRate;
    },
    confirmEdit(row) {
      const param = {
        appId: row.appId,
        orderId: row.orderId,
        withdrawExchangeRate: this.withdrawExchangeRateVar,
        rechargeExchangeRate: this.rechargeExchangeRateVar
      }

      this.$axios
          .put('/depositWithdraw/edit-exchange-rate', param)
          .then(res => {
            if (res.code === 200) {
              this.$notify.success({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              row.withdrawExchangeRate = this.withdrawExchangeRateVar;
              row.rechargeExchangeRate = this.rechargeExchangeRateVar;
              if (row.rechargeExchangeRate !== '') {
                row.rechargeUSDAmount = row.amount / this.rechargeExchangeRateVar;
              }
              if (row.withdrawExchangeRate !== '') {
                row.withdrawUSDAmount = row.amount / this.withdrawExchangeRateVar;
              }
              return true;
            } else {
              this.$notify.error({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              return false;
            }
          }).catch(() => {
        this.unlockPage();
      });
      row.isEditMode = false;
    },
    cancelEdit(row) {
      this.rechargeExchangeRateVar = '';
      this.withdrawExchangeRateVar = '';
      row.isEditMode = false;
    },
    reset() {
      const start = moment().subtract(3, 'days').format('yyyyMMDD');
      const end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },
    formatDateTime(dealDate, dealTime) {
      if (!dealDate || dealDate.length !== 8 || !dealTime || dealTime.length !== 6) {
        return '';
      }
      const date = `${dealDate.slice(0, 4)}-${dealDate.slice(4, 6)}-${dealDate.slice(6, 8)}`;
      const time = `${dealTime.slice(0, 2)}:${dealTime.slice(2, 4)}:${dealTime.slice(4, 6)}`;
      return `${date} ${time}`;
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/depositWithdraw/statistics-recharge-withdraw/export", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.rechargeWithdrawStatisticsExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
  },
  created() {
    this.$axios
        .get('/merchant/selectListForOption', {params: {}})
        .then(res => {
          this.merchantList = res.data
          if (this.merchantList.length === 1) {
            this.form.appId = this.merchantList[0].value
            this.$bus.$emit('refresh')
          }
        })
  }, unlockPage() {
    if (this.loading !== null) {
      this.loading.close();
    }
  },
}
</script>

<style scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>